module.exports = __webpack_public_path__ + "static/media/Asset 19.828b9cb6.webp";